



































import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

@Component

export default class ComponentCalculadoraDialogSelectTabela extends Vue {
  @Prop(Boolean) show
  @Prop(Object) calculadora

  @Emit('close')
  close() {}

  @Emit('showModalProcedimentosList')
  showModalProcedimentosList() {}
}
